import { useEffect } from "react"

interface ShortcutOptions {
    onUndo?: () => void
    onRedo?: () => void
    onDelete?: () => void
}

export const useKeyboardShortcuts = ({ onUndo, onRedo, onDelete }: ShortcutOptions) => {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            const isCmdOrCtrl = event.ctrlKey || event.metaKey
            const isShift = event.shiftKey
            const key = event.key.toLowerCase()

            const target = event.target as HTMLElement
            if (["INPUT", "TEXTAREA"].includes(target.tagName) || target.isContentEditable) {
                return
            }

            if (isCmdOrCtrl && !isShift && key === "z") {
                event.preventDefault() // Stop browser undo
                onUndo?.()
            }

            if (isCmdOrCtrl && isShift && key === "z") {
                event.preventDefault() // Stop browser redo
                onRedo?.()
            }

            if (isCmdOrCtrl && (key === "backspace" || key === "delete")) {
                event.preventDefault()
                onDelete?.()
            }
        }

        window.addEventListener("keydown", handleKeyDown)
        return () => window.removeEventListener("keydown", handleKeyDown)
    }, [onUndo, onRedo, onDelete])
}
